import { render, staticRenderFns } from "./Fonts.vue?vue&type=template&id=56e8b6a7"
import script from "./Fonts.vue?vue&type=script&lang=js"
export * from "./Fonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports